import AceEditor from "react-ace";
import { useContext, useEffect } from "react";

import modeCss from "ace-builds/src-noconflict/mode-css";
import modeJavascript from "ace-builds/src-noconflict/mode-javascript";
import theme from "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
import { config } from "ace-builds";
import { Context } from '../PlayerBuilderContext';
import { useState } from "react";
import { InitOptions } from "../../types/player";
import 'ace-builds/webpack-resolver';
import { init } from "i18next";
import { get } from "lodash";



export default function Editor(props: { language: any, value: string, readOnly: boolean, onChange: any }): JSX.Element {

    const { diffOptions }: any = useContext(Context);

    const { language, value, readOnly, onChange } = props;

    const [code, setCode] = useState(value);

    useEffect(() => {
        setCode(value);
      }, [value]);


    if (language == 'css')
        config.setModuleUrl("ace/mode/css", modeCss);
    else
        config.setModuleUrl("ace/mode/javascript", modeJavascript);
    config.setModuleUrl("ace/theme/github", theme);

    let id = Math.random().toString(36).substring(7);

    /*function onChange(newValue: any) {
        console.log("change", newValue);
        events.emit('updateCode', language, newValue);
    }*/

    //let value = getJs(diffOptions);

    return (
        <AceEditor
            height={'100%'}
            width={'100%'}
            mode={language}
            setOptions={{
              useWorker: false,
              showPrintMargin: false,
              tabSize: 2,
              useSoftTabs: true
            }}
            theme="monokai"
            onChange={(value) =>{
                setCode(value);
                onChange(value);
            }}
            name={"editor-" + language + "-" + id}
            readOnly={readOnly}
            editorProps={{ $blockScrolling: true }}
            value={code}
        />
    );
}
